import { isPlatformBrowser } from '@angular/common';
import { DemoBadgeComponent } from './games/shared/demo-badge/demo-badge.component';

import { ChangePasswordComponent } from './pages/change-password/change-password/change-password.component';
import {
  FormGroup,
  NgForm,
  NgModel,
  ReactiveFormsModule,
} from '@angular/forms';

import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  HostListener,
  Inject,
  Input,
  NgModule,
  OnChanges,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  SimpleChanges,
  inject,
} from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import { SplashScreenComponent } from './components/splash-screen/splash-screen.component';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NewPasswordComponent } from './pages/new-password/new-password.component';
import { ChatComponent } from '../app/components/chat/chat.component';
import { GameService } from './Services/game.service';
import { filter, Subject, Subscription, takeUntil } from 'rxjs';
import { FooterComponent } from './components/footer/footer.component';
import { CustomerReviewsComponent } from './pages/landing-page/customer-reviews/customer-reviews.component';
import { AboutUsComponent } from './pages/landing-page/about-us/about-us.component';
import { GamePromoBannerComponent } from './pages/landing-page/game-promo-banner/game-promo-banner.component';
import { OnBoardingStepsComponent } from './pages/landing-page/on-boarding-steps/on-boarding-steps.component';
import { GamesLandingComponent } from './pages/landing-page/games-landing/games-landing.component';
import { SubscribeNewslettergeComponent } from './pages/landing-page/subscribe-newsletterge/subscribe-newsletterge.component';
import { SignUpPopUpComponent } from './pages/signup/sign-up-pop-up/sign-up-pop-up.component';
import { UtilsService } from './Services/utils.service';
import { ToastrService } from 'ngx-toastr';
import { ForgotChangePasswordComponent } from './forgot-change-password/forgot-change-password.component';
import { ApiCallService } from './Services/api-call-service.service';
import { ErrorhandlingService } from './Services/error-handling.service';
import { LoaderService } from './Services/loader-service.service';
import { ActivityTrackService } from './Services/activity-track.service';
import { ComingSoonComponent } from './components/coming-soon/coming-soon.component';
import { AddWalletComponent } from './common/add-wallet/add-wallet.component';
import { UserManualComponent } from './common/user-manual/user-manual.component';
import { CommonModalComponent } from './common/common-modal/common-modal.component';
import { DevToolsGuardModalComponent } from './games/shared/devtools-guard/devtools-guard-modal.component';
import { DevToolsWarningStateService } from './games/shared/devtools-guard/devtools-warning-state.service';
import { PwaInstallService } from './Services/pwa-install.service';
import { GameAvailabilityService } from './games/shared/game-availability.service';
import { GameGuardService } from './games/shared/devtools-guard/game-guard.service';
import { GlobalSecurityService } from './Services/global-security.service';
import {
  faEye,
  faEyeSlash,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

declare let fbq: Function;
declare var gtag: Function;

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    DemoBadgeComponent,
    RouterOutlet,
    CommonModule,
    HeaderComponent,
    SplashScreenComponent,
    ChatComponent,
    NgxSpinnerModule,
    AddWalletComponent,
    FooterComponent,
    UserManualComponent,
    CommonModalComponent,
    DevToolsGuardModalComponent,
    FontAwesomeModule
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  showSplashScreen = true;

  onSplashFinished(): void {
    this.showSplashScreen = false;
    this.cdr.markForCheck();
  }
  isChatOpen = false;
  addBalance = false;
  showCharacterImage = false;
  VerifyModal = false;

  public pwaInstall = inject(PwaInstallService);
  private toastr = inject(ToastrService);
  private gameAvailability = inject(GameAvailabilityService);
  private gameGuard = inject(GameGuardService);
  private globalSecurity = inject(GlobalSecurityService);
  readonly devToolsWarning = inject(DevToolsWarningStateService);
  public showInstallFloating: boolean = true;

  private isBrowser: boolean;

  redirectToSignup() {
    this.cdr.markForCheck();
    this.cdr.detectChanges();
    this.router.navigate(['/SignUp']);
  }

  constructor(
    public router: Router,
    private gameService: GameService,
    private _utils: UtilsService,
    private apiCallService: ApiCallService,
    public ErroHandling: ErrorhandlingService,
    private _loaderService: LoaderService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.token) {
          this.getChatCount();
        }
      }
    });

    this.ErroHandling.showModalSubject.pipe(takeUntil(this.destroy$)).subscribe((val: boolean) => {
      this.addBalance = val;
    });

    this.ErroHandling.modalState$.pipe(takeUntil(this.destroy$)).subscribe(status => {
      this.VerifyModal = status;
    });

    this.isBrowser = isPlatformBrowser(this.platformId);
    if (this.isBrowser) {
      this.gameAvailability.start();
      this.gameGuard.start();
    }

    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((event: NavigationEnd) => {
        this.handleRouteChange(event.urlAfterRedirects);

        if (this.isBrowser) {
          if (typeof fbq === 'function') {
            fbq('track', 'PageView');
          }

          try {
            window.scrollTo({ top: 0, left: 0 });
          } catch (e) {
            // ignore
          }
        }
      });

    if (this.isBrowser) {
      this.handleScreenSize();
    }
  }

  private destroy$ = new Subject<void>();
  private subscription!: Subscription;

  isShowBonusBanner(): boolean {
    if (!this.isBrowser) return false;

    const currentUrl = this.router.url;
    const hasToken = !!localStorage.getItem('token');

    if (hasToken || currentUrl.includes('/dashboard')) {
      return false;
    }

    return (
      currentUrl === '/' ||
      currentUrl.includes('/login') ||
      currentUrl.includes('/SignUp')
    );
  }

  showBonusFloating: boolean = true;

  dismissBonusFloating(event?: MouseEvent): void {
    if (event) {
      event.stopPropagation();
    }
    this.showBonusFloating = false;
  }

  isBonusButton(): boolean {
    if (!this.showBonusFloating) return false;
    if (!this.isBrowser) return false;

    const currentUrl = this.router.url;
    const hasToken = !!localStorage.getItem('token');

    if (hasToken || currentUrl.includes('/dashboard')) {
      return false;
    }

    return currentUrl === '/';
  }

  shouldShowInstallFloating(): boolean {
    return (
      this.showInstallFloating &&
      this.isBonusButton() &&
      !this.pwaInstall.isInstalled()
    );
  }

  private isHiddenLayoutRoute(url: string): boolean {
    const currentUrl = url.split('?')[0];
    return [
      '/',
      '/login',
      '/SignUp',
      '/ForgotPassword',
      '/VerifyPayment',
      '/VerifyEmail',
      '/reset-pass',
      '/Terms&Condition',
      '/Terms&Conditions',
      '/PrivacyPolicy',
      '/Help',
      '/dashboard/Terms&Conditions',
      '/dashboard/PrivacyPolicy',
      '/dashboard/help-support',
    ].includes(currentUrl);
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      // Initialize full-site inspection lock and developer tools guard
      this.globalSecurity.initSecurity();
    }

    this._utils.showComponent$.pipe(takeUntil(this.destroy$)).subscribe((show) => {
      this.isChatOpen = show;
      console.log('this.isChatOpen', this.isChatOpen);
      if (!show && this.token) {
        this.getChatCount();
      }
    });

    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((event) => {
      if (event instanceof NavigationStart) {
        this._utils.toggleComponentVisibility(false);
      }
    });

    if (this.token) {
      this.getChatCount();
    }

    const token = this._utils.getItem('token');
    if (token && token !== '') {
      this.getChatCount();
    }

    this.ErroHandling.showModalSubject.pipe(takeUntil(this.destroy$)).subscribe(
      (value: boolean) => (this.addBalance = value)
    );

    setTimeout(() => {
      this.showSplashScreen = false;
    }, 2500);

    this.subscription = this._utils.showComponent$.pipe(takeUntil(this.destroy$)).subscribe((show) => {
      this.isChatOpen = show;
    });

    this.gameService
      .getTriggerObservable()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.toggleChat();
      });

    this._utils
      .getTriggerChatUnReadCountObservable()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.getChatCount();
      });

    this._utils
      .getTriggerChatReadObservable()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.readChatCounts();
      });

    if (this.isShowBonusBanner()) {
      this.getSignupBonus();
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) this.subscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  handleRouting() {
    const token = localStorage.getItem('token');
    const realPath = window.location.pathname;

    if (realPath.startsWith('/check')) {
      return;
    }

    const currentUrl = this.router.url;

    if (token && currentUrl === '/') {
      this.router.navigate(['/dashboard/home']);
    } else if (!token && currentUrl !== '/') {
      this.router.navigate(['/']);
    }
  }

  ngAfterViewInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {}

  openChatHandler() {
    console.log('AppComponent: openChatFromHeader received');
    this.isChatOpen = true;
    this._utils.toggleComponentVisibility(true);
  }

  shouldShowChat(): boolean {
    const currentUrl = this.router.url;
    const showChat = !(
      currentUrl.includes('login') ||
      currentUrl.includes('SignUp') ||
      currentUrl.includes('ForgotPassword') ||
      currentUrl.includes('VerifyPayment') ||
      currentUrl.includes('VerifyEmail') ||
      currentUrl.includes('reset-pass') ||
      currentUrl.includes('check') ||
      currentUrl.includes('dashboard/treasure-pick') ||
      currentUrl.includes('dashboard/stack-builder') ||
      currentUrl.includes('dashboard/ace-win') ||
      currentUrl.includes('dashboard/card-brag-3') ||
      currentUrl.includes('dashboard/lucky-trigger') ||
      currentUrl.includes('dashboard/joker-777') ||
      currentUrl.includes('dashboard/sum-dice') ||
      currentUrl.includes('dashboard/slot-777') ||
      currentUrl.includes('dashboard/cashbull') ||
      currentUrl.includes('dashboard/space-hunt') ||
      currentUrl.includes('dashboard/aviator') ||
      currentUrl.includes('dashboard/baccarat') ||
      currentUrl.includes('dashboard/roulette') ||
      currentUrl.includes('dashboard/chickenroad') ||
      currentUrl.includes('dashboard/mines') ||
      currentUrl.includes('dashboard/StackBuilder') ||
      currentUrl.includes('dashboard/keno') ||
      currentUrl.includes('dashboard/plinko') ||
      currentUrl.includes('dashboard/double') ||
      currentUrl.includes('dashboard/toss') ||
      currentUrl.includes('dashboard/slots') ||
      currentUrl === '/' ||
      this.showSplashScreen
    );
    return showChat;
  }

  shouldshowheader(): boolean {
    const currentUrl = this.router.url;
    const showChat = !(
      currentUrl.includes('login') ||
      currentUrl.includes('SignUp') ||
      currentUrl.includes('ForgotPassword') ||
      currentUrl.includes('VerifyPayment') ||
      currentUrl.includes('VerifyEmail') ||
      currentUrl.includes('reset-pass') ||
      currentUrl === '/' ||
      this.showSplashScreen
    );
    return showChat;
  }

  get token(): string | null {
    if (!this.isBrowser) {
      return null;
    }
    return localStorage.getItem('token');
  }

  unreadCounts: number = 0;
  signupBonus: number = 0;

  getSignupBonus() {
    try {
      this.apiCallService
        .GetCallWithoutToken('TestImonials/GetSignupBonus')
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (response) => {
            if (response.responseCode === 200) {
              this.signupBonus = response?.data;
            }
          },
          error: (error) => {},
        });
    } catch (error: any) {}
  }

  async getChatCount() {
    this.cdr.detectChanges();
    this.cdr.markForCheck();
    try {
      await this.apiCallService
        .GetCallWithToken('NotificationMessages/GetUnReadChatMessages')
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (response) => {
            if (response.responseCode === 200) {
              this.unreadCounts = response.data[0].UnreadCount;
            }
          },
          error: (error) => {},
        });
    } catch (error: any) {}
  }

  async readChatCounts() {
    this.cdr.detectChanges();
    this.cdr.markForCheck();
    try {
      await this.apiCallService
        .PostCallWithToken(null, 'NotificationMessages/ReadChatMessages')
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (response) => {
            if (response.responseCode === 200) {
              this.unreadCounts = 0;
            }
          },
          error: (error) => {},
        });
    } catch (error: any) {}
  }

  toggleChat(): void {
    const newState = !this.isChatOpen;
    this._utils.toggleComponentVisibility(newState);
    if (newState) {
      this._utils.triggerChatReadFunction();
    }
  }

  OpenDownload() {
    this.cdr.detectChanges();
    this.cdr.markForCheck();
    this._loaderService.show();

    this.apiCallService
      .GetCallWithToken('AppVersion/GetAppVersion')
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          if (response && response.responseCode === 200) {
            const filePath = response?.data?.appUpdateUrl;

            const link = document.createElement('a');
            link.href = filePath;
            link.download = 'social.apk';
            link.target = '_blank';

            link.click();
            link.remove();
            this._loaderService.hide();
            this.cdr.detectChanges();
            this.cdr.markForCheck();
          } else {
            this.ErroHandling.handleResponseError(response);
            this._loaderService.hide();
            this.cdr.detectChanges();
            this.cdr.markForCheck();
          }
        },
        error: (error) => {
          this.ErroHandling.handleHttpError(error);
        }
      });
  }

  async installFloating(): Promise<void> {
    try {
      if (this.pwaInstall.isInstalled()) {
        this.showInstallFloating = false;
        return;
      }

      const result = await this.pwaInstall.promptInstall();
      if (result === 'unavailable') {
        this.toastr.info(
          'To install: open your browser menu (⋮ or …) → "Install app" or "Add to Home Screen".',
          'Install Luckycrest',
          { timeOut: 6000, positionClass: 'toast-top-center' }
        );
      } else if (result === 'accepted') {
        this.showInstallFloating = false;
        this.toastr.success('App installed successfully!', 'Luckycrest', {
          timeOut: 3000,
        });
      }
    } catch (e) {
      // ignore
    }
  }

  hideInstallFloating(event: Event) {
    event.stopPropagation();
    this.showInstallFloating = false;
  }

  showButton: boolean = true;
  hideButton() {
    this.showButton = false;
  }

  @HostListener('window:resize')
  onResize() {
    if (this.isBrowser) {
      this.handleScreenSize();
    }
  }

  private allowedRoutes = [
    '/dashboard/home',
    '/dashboard/wallet',
    '/dashboard/account',
    '/dashboard/lottery',
    '/dashboard/redeem',
    '/dashboard/scratch',
    '/dashboard/lottery-history',
    '/',
    '/dashboard/spinner',
  ];

  handleRouteChange(url: string) {
    if (!this.isBrowser) return;

    const cleanUrl = url.split('?')[0];
    const isLargeScreen = window.innerWidth >= 1024;

    this.showCharacterImage =
      this.allowedRoutes.includes(cleanUrl) && isLargeScreen;
  }

  handleScreenSize() {
    if (!this.isBrowser) return;

    const currentUrl = this.router.url.split('?')[0];
    const isLargeScreen = window.innerWidth >= 1024;

    this.showCharacterImage =
      this.allowedRoutes.includes(currentUrl) && isLargeScreen;
  }

  isTreasurePickRoute(): boolean {
    const current = this.router.url;
    return (
      current === '/dashboard/treasure-pick' ||
      current === '/dashboard/stack-builder' ||
      current === '/dashboard/ace-win' ||
      current === '/dashboard/lucky-trigger' ||
      current === '/dashboard/card-brag-3' ||
      current === '/dashboard/space-hunt' ||
      current === '/dashboard/sum-dice' ||      
      current === '/dashboard/aviator' ||
      current === '/dashboard/joker-777' ||
      current === '/dashboard/cashbull' ||
      current === '/dashboard/slot-777' ||
      current === '/dashboard/baccarat'
    );
  }

  faEye = faEye;
  faEyeSlash = faEyeSlash;
  showPasswordText = false;
  showConfirmPasswordText = false;

  readonly RULES = {
    length: /^.{8,}$/,
    uppercase: /[A-Z]/,
    digit: /\d/,
    special: /[@$!%*?&#^()_\-+=\[\]{}|;:',.<>\/]/
  };

  closeDialog() {
    this.ErroHandling.hideVerifyModal();
  }

  isPasswordValid(password: string): boolean {
    if (!password) return false;
    return this.RULES.length.test(password) &&
      this.RULES.uppercase.test(password) &&
      this.RULES.digit.test(password) &&
      this.RULES.special.test(password);
  }

  getUsername(): string | null {
    return localStorage.getItem('userName');
  }

  sendOtpLogic(email: string, password: string) {
    this._loaderService.show();
    const payload = {
      email: email,
      username: this.getUsername(),
      password: password,
    };

    this.cdr.detectChanges();
    this.cdr.markForCheck();
    this.apiCallService
      .PostCallWithoutToken(payload, 'User/SendMailToVerifyUser')
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          this._loaderService.hide();
          if (response && response.responseCode === 200) {
            this.cdr.detectChanges();
            this.cdr.markForCheck();
            this.ErroHandling.hideVerifyModal();
            const dialogRef = this.openPopup(false, email);
            dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(() => {});
          } else {
            this.ErroHandling.handleResponseError(response);
          }
        },
        error: (error: any) => {
          this.ErroHandling.handleHttpError(error);
          this._loaderService.hide();
        }
      });
  }

  openPopup(
    isGoogleLogin: boolean = false,
    data: any = null,
  ): MatDialogRef<SignUpPopUpComponent> {
    const email = data;
    const dialogRef = this.dialog?.open(SignUpPopUpComponent, {
      width: '400px',
      disableClose: true,
      data: { email, isGoogleLogin },
    });

    if (this.window) {
      this.window.document.body.style.overflow = 'hidden';
    }

    this.cdr.detectChanges();
    this.cdr.markForCheck();
    setTimeout(() => this.cdr.detectChanges());

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(() => {
      if (this.window) {
        this.window.document.body.style.overflow = '';
      }
    });

    return dialogRef;
  }

  window: Window | null = null;
}